export default __webpack_public_path__ + "static/media/USRoadQuoteRate.ca7cca0a.png";